module.exports = __webpack_public_path__ + "img/successCat.0e3e8501.png";